/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router";
import GameViewCategory from "@/pages/game/compo/GameViewCategory";
import type { Prop_GameInfo } from "@/pages/_common/define";
import { SessionStore } from "@/store/SessionStore";

function LiveMessageBox({message}:any){
  return <>
    <div className="sticky top-0 px-0 py-2 z-50">
      <div className="bg-white shadow-md 
        p-2
        border-2 border-lime-300 rounded-lg
      ">
        {/* 경기목록은 스크롤해서 보실수 있습니다. 실시간으로 순위정보로 갱신됩니다. */}
        <div className="text-sm" dangerouslySetInnerHTML={{__html:message} } />
      </div>
    </div>
  </>
}

export default function LayoutGameView(){
  const params = useParams();
  const [gameInfo, set_gameInfo]=useState<Prop_GameInfo|null>(null);
  const [liveMessage, set_liveMessage]=useState<string>('');

  useEffect(()=>{
    const proc = async()=>{
      const { data } = await axios.post("/game/info", {
        game_code: params.game_code,
      });
      set_gameInfo( data.info );

      await SessionStore.init({game_code:params.game_code});
      //console.log("start ", UserInfoStore.userCode);
      // SessionStore.on("connect", (_socket: Socket) => {
        //console.log(">connect", socket.id);
      // });
      // SessionStore.on("disconnect", (_socket: Socket) => {
        //console.log(">connect", socket.id);
      // }); 
      SessionStore.on("notice", (data:any) => {
        //console.log(">notice", data );
        set_liveMessage( data.msg );
      }); 
      SessionStore.on("lastmessage", (data:any) => {
        //console.log(">lastmessage", data );
        set_liveMessage( data.msg );
      }); 
    };
    proc();
    return()=>{
      SessionStore.disconnect();
    }
  },[params.game_code])

  return (
    <div className="flex flex-col">
      
      {gameInfo&&
        <div className="bg-zinc-100">
          {/* <div>{params.game_code}</div> */}
          <div className="p-1">
            <div className="
              w-full bg-white border border-zinc-200 rounded-lg p-2 pb-0
              shadow-md
            ">
              <div dangerouslySetInnerHTML={{__html:gameInfo.subject}} className="font-bold text-[1rem] text-center"/>
              <GameViewCategory />
            </div>
            
            {(liveMessage!='<p></p>'&&liveMessage!='')&&<LiveMessageBox message={liveMessage} />}
            <Outlet context={gameInfo} />          
          </div>

        </div>
      }
    </div>
  );
}